export const apiConstants={
  API_SERVER_URL: process.env.REACT_APP_API_SERVER_URL,
  SWAGGER_URL: process.env.REACT_APP_SWAGGER_URL,
  DOCUMENT_URL: process.env.REACT_APP_DOCUMENT_URL,
}
export const fileUploadConstants={
  FILE_UPLOAD_URL:apiConstants.API_SERVER_URL+'file/uploadFile',
  DATA_UPLOAD_URL:apiConstants.API_SERVER_URL+'company/fileUpload',
}
